// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"94165f2d","323":"80d18b4c","332":"ec4fe4a0","375":"77eda484","421":"27884d4f","451":"7c2110db","453":"c1817f12","496":"92802c31","589":"2dfe7882","591":"cb922910","619":"9f29f740","685":"3bef821a","773":"44f4c493","857":"476ef690","959":"223de654"}[chunkId] + ".chunk.js";
};